var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.user_data.sponsor_type == 3)?_c('basic-booth-preview'):_vm._e(),(_vm.user_data.sponsor_type == 4)?_c('gold-booth-preview'):_vm._e(),(_vm.user_data.sponsor_type == 6)?_c('diamond-booth-preview'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }